import React from "react";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    line: {
        flexGrow: 1,
        height: 2,
        backgroundColor: theme.palette.primary.dark,
    },
    text: {
        padding: `0 ${theme.spacing(2)}px`,
        color: theme.palette.primary.dark,
        whiteSpace: "nowrap",
        textTransform: "uppercase",
        fontWeight: "bold",
    },
}));
export const DividerWithText = ({ children, className = "", }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: `${classes.root} ${className}` },
        React.createElement("div", { className: classes.line }),
        React.createElement("span", { className: classes.text }, children),
        React.createElement("div", { className: classes.line })));
};
